module.exports = __webpack_public_path__ + "static/media/ribbon.38b22107.png";